export default __webpack_public_path__ + "static/media/logo-nursing-academics.dcaa892a.svg";